import React, { useState } from "react";

// Logos served via logo.dev (public CDN). If a logo fails or returns a generic
// placeholder, we fall back to the company name in italic serif so the marquee
// still feels elegant and on-brand.
const LOGO_TOKEN = "pk_X-1ZO13GSgeOoUrIuJ6GMQ";
const logoUrl = (domain) =>
  `https://img.logo.dev/${domain}?token=${LOGO_TOKEN}&size=240&format=png&retina=true`;

const CLIENTS = [
  { name: "Clayworks", domain: "clayworks.in" },
  { name: "Scaler School of Technology", domain: "scaler.com" },
  { name: "TheMathCompany", domain: "themathcompany.com" },
  { name: "Dino Ventures" }, // no reliable public logo — text fallback
  { name: "Snabbit", domain: "snabbit.in" },
  { name: "BPL Medicals", domain: "bplmedicaltechnologies.com" },
  { name: "91Springboard", domain: "91springboard.com" },
  { name: "Zolo", domain: "zolostays.com" },
  { name: "JFrog", domain: "jfrog.com" },
  { name: "Jusjumpin", domain: "jusjumpin.com" },
];

function ClientLogo({ client, idx }) {
  const [failed, setFailed] = useState(false);
  const showLogo = !failed && client.domain;

  return (
    <div
      data-testid={`client-logo-${idx}`}
      className="shrink-0 flex flex-col items-center justify-center gap-3 px-6 md:px-8 min-w-[180px] md:min-w-[220px]"
      title={client.name}
    >
      <div className="h-14 md:h-16 flex items-center justify-center">
        {showLogo ? (
          <img
            src={logoUrl(client.domain)}
            alt={`${client.name} logo`}
            loading="lazy"
            onError={() => setFailed(true)}
            className="max-h-12 md:max-h-14 w-auto object-contain"
          />
        ) : (
          <span className="font-serif italic text-[#1E3A5F]/70 text-3xl md:text-4xl tracking-tight whitespace-nowrap">
            {client.name}
          </span>
        )}
      </div>
      <span className="text-[11px] md:text-xs uppercase tracking-[0.22em] text-[#1E3A5F]/70 whitespace-nowrap font-sans-brand">
        {client.name}
      </span>
    </div>
  );
}

export default function Clients() {
  const track = [...CLIENTS, ...CLIENTS];
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 text-center">
        <p className="label-eyebrow">07 · Trusted By</p>
        <h2 className="font-serif text-[#1E3A5F] mt-5 text-3xl md:text-4xl lg:text-5xl leading-tight max-w-3xl mx-auto">
          Bengaluru's most considered companies
          <span className="italic text-[#CBA365]"> break bread with us.</span>
        </h2>
      </div>

      <div className="mt-16 relative overflow-hidden">
        <div className="marquee-track flex items-center gap-6 md:gap-10 whitespace-nowrap w-max">
          {track.map((client, idx) => (
            <ClientLogo key={`${client.name}-${idx}`} client={client} idx={idx} />
          ))}
        </div>

        {/* edge fade */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-[#FDFBF7] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-[#FDFBF7] to-transparent" />
      </div>
    </section>
  );
}
